import { render, staticRenderFns } from "./Types.vue?vue&type=template&id=0f35f6fe&lang=html"
import script from "./Types.vue?vue&type=script&lang=js"
export * from "./Types.vue?vue&type=script&lang=js"
import style0 from "./Types.vue?vue&type=style&index=0&id=0f35f6fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports